
export const channelEmail = "EMAIL";
export const channelSms = "SMS";
export const channelAll = "ALL";